export { AmbassadorsMap, default } from "./AmbassadorsMap";
